<template>
  <div :class="['wrapper', { 'wrapper__paddingless': !!this.mode }]">
    <CustomCheckbox
      v-if="this.showCheckbox() && this.floorsPlan?.length"
      :value="allSelected"
      @change="selectAll"
      :small="true"
      style="margin-bottom: 15px;"
      label="Выбрать все"
    />
    <div
      v-if="this.floorsPlan?.length"
      v-for="floor in this.floorsPlan"
      :key="floor.floor_map_id"
      class="floor"
    >
      <CustomCheckbox
        v-if="this.showCheckbox(floor)"
        :value="floor?.is_selected"
        @change="(value) => onCheckboxChange(floor, value)"
        :small="true"
      />
      <div
        v-else-if="this.mode === 'flat-grouping' || this.mode === 'floor-grouping'"
        style="width: 30px;"
      ></div>
      <div class="floorNum-row">
        <span class="floorNum">{{ floor.floor }}</span>
        <q-btn
          v-if="onDeleteFloor && floor?.smeta_status_code && floor.smeta_status_code !== 'SUCCESS'"
          flat
          dense
          round
          size="sm"
          icon="delete"
          color="negative"
          class="floorNum-row__delete"
          @click="onDeleteFloor(floor)"
        >
          <q-tooltip>Удалить этаж</q-tooltip>
        </q-btn>
      </div>
      <div class="apartments">
        <div
          v-for="apartment in floor.flat"
          :key="apartment.flat_id"
          :class="['apartment', { apartment__small: !!this.mode, apartment__cursorPointer: !this.mode }]"
          @click="() => this.onApartmentClick && this.onApartmentClick({...apartment, floor: floor.floor, floor_map_id: floor.floor_map_id, colour_id: floor.colour_id }, )"
          :style="`background-color: ${this.getCellColor(floor, apartment)}`"
        >
          <q-tooltip anchor="top middle" self="bottom middle">
            <p v-if="apartment.remont_id" style="margin: 0; font-size: 13px;">
              remont_id = {{ apartment.remont_id }}
            </p>
            <p v-if="apartment.flat_id" style="margin: 0; font-size: 13px;">
              flat_id = {{ apartment.flat_id }}
            </p>
            <p v-if="apartment.floor_flat_id" style="margin: 0; font-size: 13px;">
              floor_flat_id = {{ apartment.floor_flat_id }}
            </p>
          </q-tooltip>
          <q-btn
            v-if="!this.mode && apartment.flat_id"
            flat
            dense
            round
            size="xs"
            icon="close"
            color="negative"
            class="apartment__deleteBtn"
            @click.stop="() => this.handleDeleteApartment(apartment, floor)"
          />
          <span class="apartmentRoomCnt">
            {{ apartment.room_cnt }}
          </span>
          <span class="apartmentInfo">{{ apartment.area }} м²</span>
          <span class="apartmentInfo">кв. {{ apartment.flat_num }}</span>
          <span
            v-if="!!apartment.remont_id"
            class="apartmentInfo"
            style="font-size: 11px;"
          >
            #{{ apartment.remont_id }}</span
          >
        </div>
      </div>
      <div v-if="!!this.getFloorData && !this.mode" style="font-weight: 500;">
        <q-tooltip> Контрольная сумма </q-tooltip>
        {{ this.getFloorData(floor.floor) }}
      </div>
      <div
        v-if="floor?.smeta_status_code && !this.mode"
        style="font-weight: 500; display: flex; align-items: center; gap: 8px; flex-wrap: wrap;"
      >
        <div>
          <div
            :class="`text-subtitle2 ${floor?.smeta_status_code === 'SUCCESS' ? 'text-green-7' : 'text-deep-orange-14'}`"
            style="width: fit-content; line-height: 17px; white-space: nowrap;"
          >
            {{floor?.smeta_status_code === 'SUCCESS' ? 'Успешно рассчитана смета' : 'Ошибка'}}
            <q-icon v-if="!!floor.smeta_error" name="info" />
            <q-tooltip v-if="floor.smeta_error" class="bg-red text-caption">
              {{ floor.smeta_error }}
            </q-tooltip>
          </div>
          <div class="text-caption" style="line-height: 15px;">
            Последний пересчет:
            {{ floor.smeta_recalc_date }}
          </div>
        </div>
      </div>
      <div
        v-if="this.smetaLoading && this.smetaLoading[floor.floor_map_id]"
        style="width: 20px;"
      >
        <CustomLoader small v-if="this.smetaLoading[floor.floor_map_id]" />
      </div>
      <CustomSelect
        v-if="this.mode === 'grouping' && !!floor.floor_map_id"
        :options="this.colors"
        label="Группа"
        style="width: 100px;"
        optionValueKey="colour_id"
        optionLabelKey="label"
        :value="floor.colour_id"
        @change="value => this.onGroupChange(value, floor.floor_map_id, floor.floor)"
        :clearable="false"
        :colorMode="true"
      />
      <div class="gprInfo" v-if="(floor.gpr_plan_start || floor.gpr_fact_start) && !this.mode">
        <div v-if="floor.gpr_plan_start" class="gprBlock">
          <div class="gprLabel">Период план:</div>
          <div class="gprDates">{{ floor.gpr_plan_start }} - {{ floor.gpr_plan_end }}</div>
        </div>
        <div v-if="floor.gpr_fact_start" class="gprBlock" style="margin-top: 8px;">
          <div class="gprLabel">Период факт:</div>
          <div class="gprDates" style="display: flex; align-items: center; flex-wrap: wrap;">
            <span>{{ floor.gpr_fact_start }}</span>
            <span v-if="floor.gpr_deviation_start !== undefined && floor.gpr_deviation_start !== null && floor.gpr_deviation_start !== 0"
                  :class="{'text-red': floor.gpr_deviation_start > 0, 'text-green': floor.gpr_deviation_start < 0}"
                  style="font-size: 11px; margin-left: 2px; margin-right: 4px; font-weight: 600;">
              ({{ floor.gpr_deviation_start > 0 ? '+' : '' }}{{ floor.gpr_deviation_start }} дн)
            </span>
            <span style="margin: 0 4px;">-</span>
            <span>{{ floor.gpr_fact_end }}</span>
            <span v-if="floor.gpr_deviation_end !== undefined && floor.gpr_deviation_end !== null && floor.gpr_deviation_end !== 0"
                  :class="{'text-red': floor.gpr_deviation_end > 0, 'text-green': floor.gpr_deviation_end < 0}"
                  style="font-size: 11px; margin-left: 2px; font-weight: 600;">
              ({{ floor.gpr_deviation_end > 0 ? '+' : '' }}{{ floor.gpr_deviation_end }} дн)
            </span>
          </div>
        </div>
      </div>
    </div>
    <NotFoundText
      v-else-if="!this.isFetching"
      :text="this.show ? 'Нет данных' : 'Заполните данные'"
    />
    
    <!-- Диалог подтверждения удаления квартиры -->
    <q-dialog v-model="deleteDialog.show" persistent>
      <q-card style="min-width: 400px;">
        <q-card-section>
          <div class="text-h6">Удаление квартиры</div>
        </q-card-section>
        <q-card-section>
          <p>
            Вы действительно хотите удалить квартиру {{ deleteDialog.flatNum }}?
          </p>
          <p v-if="deleteDialog.hasRelations" style="margin-top: 10px; font-weight: 500; color: #f44336;">
            Внимание: По данному помещению уже есть замеры.
          </p>
        </q-card-section>
        <q-card-actions align="right">
          <q-btn flat label="Отмена" @click="deleteDialog.show = false" />
          <q-btn unelevated color="negative" label="Удалить" @click="confirmDeleteApartment" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import CustomCheckbox from "@/components/form/CustomCheckbox";
import CustomSelect from "@/components/form/CustomSelect";
import NotFoundText from "@/components/common/NotFoundText.vue";
import { changeFloorGroup, getEntranceColors, checkFlatFloor, deleteFlat, checkFlatRelations } from "./services";
import { hexToRgba } from "@/services";
import CustomLoader from "@/components/common/CustomLoader";
import { showErrorToast, showSuccessToast } from "@/services";

export default {
  name: 'ResidentialApartmentsList',
  components: {CustomCheckbox, CustomSelect, NotFoundText, CustomLoader},
  props: ['onApartmentClick', 'floorsPlan', 'floorSmetaData', 'mode', 'updateData', 'checkboxMode', 'params', 'addData', 'getFloorData', 'isFetching', 'show', 'smetaLoading', 'onDeleteFloor'],
  data() {
    return {
      loading: {},
      creatingRemont: {},
      colors: [],
      deleteDialog: {
        show: false,
        apartment: null,
        floor: null,
        hasRelations: false,
        flatNum: '',
      },
      deleting: false,
    };
  },
  computed: {
    allSelected() {
      return this.floorsPlan?.every(item => item.is_selected)
    },
  },
  methods: {
    hexToRgba,
    async onGroupChange(colour_id, floor_map_id, floor) {
      if(this.loading[floor]) return
      const body = {
        is_new_group: colour_id === 'new_group',
        floor_map_id,
        colour_id: colour_id === 'new_group' ? null : colour_id
      }
      this.loading[floor] = true
      const res = await changeFloorGroup(body, this.params)
      this.loading[floor] = false
      if(!res) return
      this.updateData && this.updateData(res)
      this.getColors()
    },
    async getColors() {
      if(this.mode !== 'grouping') return
      const res = await getEntranceColors(this.params)
      if(!res) return
      this.colors = res
    },
    async selectAll(value) {
      const updatedData = this.floorsPlan.map(floor => ({ ...floor, is_selected: value }));
      this.updateData && this.updateData(updatedData)
    },
    showCheckbox(floor) {
      if(this.checkboxMode) return true
      if(this.mode !== 'flat-grouping' && this.mode !== 'floor-grouping') return false
      if(!floor) return false
      const {floor_map_id, colour_id} = floor

      if(this.mode === 'flat-grouping') {
        if(!floor_map_id || colour_id !== this.addData?.colour_id)
          return false
      }
      if(this.mode === 'floor-grouping') {
        if(!floor_map_id) return true
        if(colour_id !== this.addData?.colour_id) return false
      }
      return true
    },
    onCheckboxChange(floor, value) {
      const {floor_map_id, floor: key} = floor
      if(this.params?.floor_map_id === floor_map_id) return
      const updatedData = this.floorsPlan.map(floor => {
        if (floor.floor === key) {
          return { ...floor, is_selected: value };
        }
        return floor;
      });
      this.updateData && this.updateData(updatedData)
    },
    getCellColor(floor, apartment) {
      if(this.mode !== 'flat-grouping') return hexToRgba(floor.hex_code, .5)
      return checkFlatFloor(floor, apartment, this.addData) ? 'rgba(173 ,102 ,255, .5)' : hexToRgba(floor.hex_code, .5)
    },
    async handleDeleteApartment(apartment, floor) {
      if (!apartment.flat_id && !apartment.floor_flat_id) return;
      
      const floor_flat_id = apartment.floor_flat_id || apartment.flat_id;
      
      // Проверяем наличие связей перед показом диалога
      let hasRelations = false;
      try {
        const relationsRes = await checkFlatRelations(floor_flat_id);
        hasRelations = relationsRes?.has_relations || false;
      } catch (e) {
        console.error('Ошибка при проверке связей:', e);
      }
      
      // Показываем диалог с информацией о связях
      this.deleteDialog = {
        show: true,
        apartment,
        floor,
        hasRelations: hasRelations,
        flatNum: apartment.flat_num || '',
      };
    },
    async confirmDeleteApartment() {
      const apartment = this.deleteDialog.apartment;
      if (!apartment) {
        showErrorToast('Квартира не выбрана');
        return;
      }
      
      // Используем floor_flat_id, если он есть, иначе используем flat_id (backend получит floor_flat_id)
      const floor_flat_id = apartment.floor_flat_id;
      const flat_id = apartment.flat_id;
      
      if (!floor_flat_id && !flat_id) {
        showErrorToast('Не указан ID квартиры');
        return;
      }
      
      this.deleting = true;
      try {
        // Удаляем квартиру (проверка связей уже выполнена и показано предупреждение)
        const idToDelete = floor_flat_id || flat_id;
        console.log('Deleting apartment with ID:', idToDelete, 'hasRelations:', this.deleteDialog.hasRelations);
        const res = await deleteFlat(idToDelete);
        console.log('Delete response:', res);
        
        if (res?.success) {
          showSuccessToast('Квартира удалена');
          this.deleteDialog.show = false;
          
          // Обновляем локально сразу, чтобы UI обновился мгновенно
          // Удаляем квартиру из списка независимо от того, была ли она удалена или перемещена
          if (this.updateData && this.deleteDialog.floor) {
            const deleteFloorFlatId = this.deleteDialog.apartment.floor_flat_id;
            const deleteFlatId = this.deleteDialog.apartment.flat_id;
            console.log('Removing apartment from list:', { deleteFloorFlatId, deleteFlatId });
            
            const updatedFloors = this.floorsPlan.map(f => {
              if (f.floor_map_id === this.deleteDialog.floor.floor_map_id) {
                const originalLength = f.flat.length;
                const filtered = f.flat.filter(apt => {
                  const aptFloorFlatId = apt.floor_flat_id;
                  const aptFlatId = apt.flat_id;
                  // Удаляем если совпадает floor_flat_id или flat_id
                  const shouldRemove = (aptFloorFlatId && deleteFloorFlatId && aptFloorFlatId === deleteFloorFlatId) ||
                                      (aptFlatId && deleteFlatId && aptFlatId === deleteFlatId);
                  if (shouldRemove) {
                    console.log('Removing apartment:', { aptFloorFlatId, aptFlatId });
                  }
                  return !shouldRemove;
                });
                console.log(`Floor ${f.floor_map_id}: ${originalLength} -> ${filtered.length} apartments`);
                return {
                  ...f,
                  flat: filtered
                };
              }
              return f;
            });
            console.log('Updating floors plan locally:', updatedFloors);
            this.updateData(updatedFloors);
          }
          
          // Перезагружаем данные с сервера, чтобы получить актуальный список
          console.log('Emitting refresh event');
          this.$emit('refresh');
        } else {
          const errorMsg = res?.error || res?.message;
          if (errorMsg) {
            console.error('Ошибка удаления квартиры:', res);
            showErrorToast(errorMsg);
          }
        }
      } catch (e) {
        console.error('Исключение при удалении квартиры:', e);
        const errorMsg = e?.response?.data?.error || e?.response?.data?.message || e?.message;
        if (errorMsg) showErrorToast(errorMsg);
      } finally {
        this.deleting = false;
      }
    }
  },
  mounted() {
    this.getColors()
  }
};
</script>

<style scoped lang="scss">
.wrapper {
  padding: 20px;

  &__paddingless {
    padding: 0;
  }
}
.floor {
  margin-bottom: 5px; display: flex; gap: 15px; align-items: center;
}
.floorNum-row {
  display: flex;
  align-items: center;
  gap: 2px;
  min-width: 18px;

  &__delete {
    padding: 4px;
  }
}
.floorNum {
  font-size: 14px;
  font-weight: 400;
  color: #333;
  width: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.apartments {
  display: flex; gap: 5px; align-items: center;
}
.apartment {
  width: 90px;
  height: 90px; padding: 5px;
  border-radius: 12px;
  background-color: #f0f0f0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: .3s all;
  position: relative;

  &:hover {
    background-color: #d2dce3;
    
    .apartment__deleteBtn {
      opacity: 1;
    }
  }

  &__cursorPointer {
    cursor: pointer;
  }

  &__small {
    width: 70px;
    height: 70px;
  }
  
  &__deleteBtn {
    position: absolute;
    top: 2px;
    right: 2px;
    opacity: 0;
    transition: opacity 0.3s;
    z-index: 10;
  }
}
.apartmentRoomCnt {
  font-size: 16px;
  font-weight: bold;
  color: #474747;
}
.apartmentInfo {
  font-size: 12px;
  color: #474747;
}
.gprInfo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 10px;
}
.gprBlock {
  font-size: 11px;
  color: #555;
}
.gprLabel {
  font-weight: 600;
  color: #444;
  font-size: 11px;
}
.gprDates {
  color: #666;
  font-size: 11px;
}
</style>
